module.exports = __webpack_public_path__ + "static/media/video_compriamo.64f8787f.mov";